module.exports = __webpack_public_path__ + "img/HSV21 Holzbach Bild 2.b7943516.jpg";